import React from 'react';
import ServiceTech from '../../component/servicetech'
import blockchainheader from '../../assets/blockchainheader.jpg';
import blockchainkey1 from '../../assets/blockchain1.jpg';
import blockchainkey2 from '../../assets/blockchain2.jpg';
import blockchainkey3 from '../../assets/blockchain3.jpg';
const BlockChain = () => {
    const data = {
        "headerimg": blockchainheader,
        "key1img": blockchainkey1,
        "key2img": blockchainkey2,
        "key3img": blockchainkey3,
        "maintitle": "Trust is earned through transparency, and blockchain makes it unbreakable",
        "mainsub": "Building Trust with Transparent Blockchain Solutions",
        "title": "Blockchain",
        "subtext": "Our blockchain solutions provide transparency, security, and decentralized control, helping businesses establish trust in their transactions. From secure records to smart contracts, we develop customized blockchain systems that reduce fraud, automate processes, and ensure data integrity. Whether you're streamlining supply chains or building decentralized applications, we have the expertise to deliver.",
        "choose1": "We build blockchain solutions that offer secure, transparent, and immutable records of transactions, ensuring trust and accountability for all parties involved in the process.",
        "choose2": "Our blockchain solutions eliminate the need for intermediaries, giving businesses greater autonomy, reducing operational risks, and fostering trust within decentralized systems.",
        "choose3": "We implement smart contracts that streamline and automate business processes, reducing manual intervention and ensuring the accurate, seamless execution of agreements with enhanced efficiency.",
        "key1": "Transparency and Trust",
        "key2": "Transparency and Trust",
        "key3": "Enhanced Security",
        "key4": "Smart Contracts",
        "key5": "Cost Savings",
        "text1": "Blockchain technology provides an immutable ledger that ensures transparency across transactions, enabling all parties involved to trust the system without the need for intermediaries",
        "text2": "By eliminating the need for a central authority, blockchain offers decentralized control, reducing the risks associated with a single point of failure and ensuring greater autonomy in transactions",
        "text3": "Blockchains cryptographic nature ensures data integrity and security, making it extremely difficult for malicious actors to alter or hack the system, providing businesses with enhanced protection",
        "text4": "Automate agreements and transactions with smart contracts that execute predefined actions when conditions are met, reducing the need for manual processing and increasing efficiency in contractual workflows",
        "text5": "By removing intermediaries and reducing the complexities of traditional transactions, blockchain can cut costs across industries, particularly in sectors like finance, supply chain, and logistics",
        "text6": "With our expertise in Consultancy, organizations can rethink, re-engineer, and optimize their strategies for enhanced performance and sustainable growth."




    }

    return (



        <>
            <ServiceTech values={data} />
        </>



    )
};

export default BlockChain;
